import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeBoiler } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeBoiler} />; }
